// @ts-nocheck
// @ts-ignore
import axios from 'axios';
import { useDispatch } from 'react-redux';

import API_ENDPOINTS from '../../const/ApiEndPoints';
import { loginSuccess } from '../../store/slices/userSlice';

export default function useUser() {
  const dispatch = useDispatch();

  const createUser = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.CREATE_USER}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const updateUser = (body, id) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.UPDATE_USER}`,
        body,
        { params: { userid: id } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const suspendUser = (status, id) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.SUSPEND_USER}?action=${status}&user_id=${id}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getUserUsageDetails = (id) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.ROLE_LINKAGES_UPDATE}`,
        {
          params: { role_id: id },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const replaceAndDeleteUser = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.ROLE_LINKAGES_UPDATE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateUserSetting = (body, params) => {
    const config = { loader: false };
    if (params) {
      config.params =
        typeof params === 'string' ? { column_scope: params } : params;
    }
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.USER_SETTING}`,
        body,
        config
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  // The token and headers are set here because we need to call this API before our axios gets initialized and other APIs gets called, so we call this API before login using directly token.
  //  This API is only used for common auth implementation
  const getUserRelatedDetails = (token, orgName) => {
    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(orgName && { org: orgName }),
    };

    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.AUTH.USER_DETAIL}`,
        {
          ...(token && orgName
            ? {
                headers: headers,
              }
            : {}),
        }
      )
      .then((res) => {
        dispatch(
          loginSuccess({
            user: res.data.user,
            profile: res.data.profile,
            token: localStorage.getItem('access_token'),
            refresh: localStorage.getItem('refresh_token'),
          })
        );
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  return {
    createUser,
    suspendUser,
    getUserUsageDetails,
    replaceAndDeleteUser,
    updateUser,
    updateUserSetting,
    getUserRelatedDetails,
  };
}
